import { GradientIcon, Heading, useTheme } from '@sparemin/blockhead';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import DialogContent from 'components/DialogContent';
import { ClosedCaptioning } from 'components/icons';
import useContextualUpgrade from 'hooks/useContextualUpgrade';
import { onUnlockThisFeature } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';

const { useCallback } = React;

const FullEpisodeCaptionsUpsellModalContents = () => {
  const { onUpgrade } = useContextualUpgrade({ openModal: replaceModal });
  const dispatch = useDispatch();
  const { palette } = useTheme();

  const handleUpgrade = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dispatch(onUnlockThisFeature('CaptionFullVideoPodcast'));
      onUpgrade();
    },
    [dispatch, onUpgrade],
  );

  return (
    <DialogContent
      title="Add captions to full episodes"
      icon={
        <GradientIcon>
          <ClosedCaptioning color={palette.d2} />
        </GradientIcon>
      }
      details={
        <Heading level={2}>
          Unlock stylish captions to make your entire episode shine on platforms
          like YouTube while increasing its accessibility!
        </Heading>
      }
      actions={[
        {
          children: 'unlock this feature',
          key: 'unlock-cta',
          onClick: handleUpgrade,
          theme: 'rainbow',
        },
      ]}
    />
  );
};

export default FullEpisodeCaptionsUpsellModalContents;
